export default "__VITE_ASSET__B4KN2oNT__"